'use client';

import { useEffect, useState } from "react";
import Hero from "./Components/Hero";
import About from "./Components/About";
import Portfolio from "./Components/Portfolio";
import Services from "./Components/Services";
import Process from "./Components/Process";
import Contact from "./Components/ContactSection";
import Loader from "./Components/Loader";
import Head from "next/head";
import SocialSidebar from "./Components/SocialSidebar";

const PageClient = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasRendered, setHasRendered] = useState(false);

  useEffect(() => {
    const hasLoaded = sessionStorage.getItem("hasLoaded");

    // Initial load only
    if (!hasLoaded) {
      setIsLoading(true);
      sessionStorage.setItem("hasLoaded", "true");  //un comment this after website is complete

      // Prevent initial hash scroll
      window.history.replaceState(null, '', window.location.pathname);

      const timer = setTimeout(() => {
        setIsLoading(false);
        // Delay rendering actual content to avoid hash jump
        requestAnimationFrame(() => {
          setHasRendered(true);
          window.scrollTo({ top: 0, behavior: 'auto' });
        });
      }, 2000);

      return () => clearTimeout(timer);
    } else {
      // Already visited — skip loader
      setIsLoading(false);
      setHasRendered(true);
    }
  }, []);

  if (isLoading || !hasRendered) {
    return <Loader />;
  }

  return (
    <>
     <Head>
        <meta name="description" content="Explore stunning interior design projects, home decor inspiration, and creative transformations with Design Nook Interiors." />
        <meta name="keywords" content="Interior Design, Home Decor, Interior Designers, Design Inspiration, Modern Interiors, Luxury Interior Design, Design Nook Interiors" />
        <meta name="author" content="Design Nook Interiors" />
        <meta property="og:type" content="profile" />
        <meta property="og:title" content="Design Nook Interiors" />
        <meta property="og:description" content="Welcome to Design Nook Interiors! Explore our creative interior design services and inspiring transformations." />
        <meta property="og:image" content="https://yourwebsite.com/path-to-image.jpg" />
        <meta property="og:url" content="https://www.instagram.com/design_nook.interiors/" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Design Nook Interiors" />
        <meta name="twitter:description" content="Explore interior design services and transformations with Design Nook Interiors." />
        <meta name="twitter:image" content="https://yourwebsite.com/logo.png" />
        <meta name="twitter:url" content="https://www.instagram.com/design_nook.interiors/" />
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Design Nook Interiors - Interior Design Services & Inspiration</title>
        <link rel="icon" href="https://yourwebsite.com/logo.png" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link href="https://fonts.googleapis.com/css2?family=Gloock&family=Work+Sans:wght@400;600&display=swap" rel="stylesheet" />
      </Head>


    <main>
      <SocialSidebar/>
      <section>
        <Hero />
      </section>

      <section id="about" className="scroll-mt-16 ">
        <About />
      </section>

      <section id="portfolio" className="scroll-mt-16">
        <Portfolio />
      </section>

      <section>
        <Services />
      </section>

      <section>
        <Process />
      </section>

      <section id="contact" className="scroll-mt-16">
        <Contact />
      </section>
    </main>
    </>
  );
};

export default PageClient;
